import axios from 'axios'
import router from '../router'
import { ElMessage } from 'element-plus'

// 创建axios实例
const service = axios.create({
  baseURL: '/api', // api的base_url
  timeout: 60000 // 请求超时时间，设置为10分钟(600000ms)以支持大文件上传
  // 移除默认的Content-Type，让axios自动处理
})

// 定义getToken函数，从localStorage获取token
function getToken() {
  const token = localStorage.getItem('token')
  console.log('获取到的token:', token)
  return token
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    console.log('请求配置:', { url: config.url, method: config.method })
    // 从localStorage获取token并添加到请求头
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
      console.log('已添加Authorization头:', config.headers['Authorization'])
    } else {
      console.warn('未找到token，请求将不包含Authorization头')
    }
    
    // 如果是FormData，不设置Content-Type，让浏览器自动处理
    if (config.data instanceof FormData) {
      console.log('检测到FormData，移除Content-Type设置')
      delete config.headers['Content-Type']
    }
    
    return config
  },
  error => {
    // 处理请求错误
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 获取响应数据
    const responseData = response.data
    
    // 检查success=false的情况
    if (responseData && responseData.success === false) {
      // 获取错误信息
      let errorMessage = '操作失败'
      if (responseData.message) {
        errorMessage = responseData.message
      }
      
      // 使用message.error提示错误信息
      // 尝试导入message组件，如果导入失败则使用console提示
      try {
        // 假设使用的是Element Plus或类似UI库
        // const { ElMessage } = require('element-plus')
        ElMessage.error({ duration: 2000 ,message: errorMessage})
      } catch (e) {
      }
    }
    
    // 返回响应数据
    return responseData
  },
  error => {
    // 处理响应错误
    console.error('响应错误:', error)
    
    // 获取错误信息
    let errorMessage = '请求失败，请稍后重试'
    if (error.response) {
      // 服务器返回了错误响应
      if (error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message
      } else if (error.response.statusText) {
        errorMessage = error.response.statusText
      }
    } else if (error.message) {
      // 请求发送失败
      errorMessage = error.message
    }
    
    // 使用message.error提示错误信息
    // 尝试导入message组件，如果导入失败则使用console提示
    try {
      // 假设使用的是Element Plus或类似UI库
      // const { ElMessage } = require('element-plus')
      ElMessage.error(errorMessage)
    } catch (e) {
    }
    
    // 处理401未授权错误
    if (error.response && error.response.status === 401) {
      // 清除token和用户信息
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      
      // 重定向到登录页面
      router.push('/login')
    }
    
    return Promise.reject(error)
  }
)

export default service